/* Line-art nav icons for the Procurement Manager sidenav, matching the same
 * visual language as MenuHomeIcon/MenuCalendarIcon/MenuPerformanceIcon:
 * 32x32 viewBox, 2.4 stroke, round caps/joins, no fills. Each accepts a
 * `stroke` prop so the same component can render both the inactive
 * (#ADB5BD) and active (#1576BC) state — see ProcurementNavIcons.js.
 */

export const MenuApprovalsIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4H20C20.7364 4 21.3333 4.59695 21.3333 5.33333V6.66667H10.6667V5.33333C10.6667 4.59695 11.2636 4 12 4Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 5.33334H24C25.4728 5.33334 26.6667 6.52725 26.6667 8.00001V26.6667C26.6667 28.1394 25.4728 29.3333 24 29.3333H8C6.52724 29.3333 5.33334 28.1394 5.33334 26.6667V8.00001C5.33334 6.52725 6.52724 5.33334 8 5.33334H10.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 17L14.3333 20.3333L21 13.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const MenuBudgetIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 10.6667C4 9.19391 5.19391 8 6.66667 8H23.3333C24.8061 8 26 9.19391 26 10.6667V12H4V10.6667Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H24.6667C26.5077 12 28 13.4923 28 15.3333V22.6667C28 24.5076 26.5077 26 24.6667 26H6.66667C5.19391 26 4 24.8061 4 23.3333V12Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 19C21.3333 19.7364 21.9297 20.3333 22.6667 20.3333C23.4036 20.3333 24 19.7364 24 19C24 18.2636 23.4036 17.6667 22.6667 17.6667C21.9297 17.6667 21.3333 18.2636 21.3333 19Z"
        stroke={stroke}
        strokeWidth="2.4"
      />
    </svg>
  )
}

export const MenuSuppliersIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 11.3333L6.66667 4H25.3333L27.3333 11.3333"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66667 11.3333C4.66667 13.1743 6.15905 14.6667 8 14.6667C9.84095 14.6667 11.3333 13.1743 11.3333 11.3333C11.3333 13.1743 12.8257 14.6667 14.6667 14.6667C16.5076 14.6667 18 13.1743 18 11.3333C18 13.1743 19.4924 14.6667 21.3333 14.6667C23.1743 14.6667 24.6667 13.1743 24.6667 11.3333C24.6667 13.1743 26.1591 14.6667 28 14.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 14.6667V28H25.3333V14.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 28V20H18.6667V28"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const MenuPurchaseRequestsIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 4H19.3333L26.6667 11.3333V28C26.6667 28.7364 26.0697 29.3333 25.3333 29.3333H8C7.26362 29.3333 6.66667 28.7364 6.66667 28V5.33333C6.66667 4.59695 7.26362 4 8 4Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3333 4V11.3333H26.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 17.3333H21.3333"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 22.6667H21.3333"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const MenuOrdersIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6667 10.6667V8C10.6667 5.05448 13.0545 2.66667 16 2.66667C18.9455 2.66667 21.3333 5.05448 21.3333 8V10.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.14 10.6667H23.86C24.8 10.6667 25.5714 11.3808 25.6484 12.318L26.9857 28.6513C27.0716 29.6974 26.2438 30.6 25.1943 30.6H6.80571C5.75619 30.6 4.92838 29.6974 5.01426 28.6513L6.35159 12.318C6.42861 11.3808 7.19999 10.6667 8.14 10.6667Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 14.6667V16.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M20.6667 14.6667V16.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const MenuItemsIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 4L27.3333 10.6667V21.3333L16 28L4.66667 21.3333V10.6667L16 4Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66667 10.6667L16 17.3333L27.3333 10.6667"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17.3333V28"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const MenuBooksIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 8.5C14.2 6.9 11.6 6 8 6C6.8 6 5.7 6.1 4.7 6.3V24.2C5.7 24 6.8 23.9 8 23.9C11.6 23.9 14.2 24.8 16 26.4C17.8 24.8 20.4 23.9 24 23.9C25.2 23.9 26.3 24 27.3 24.2V6.3C26.3 6.1 25.2 6 24 6C20.4 6 17.8 6.9 16 8.5Z"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 8.5V26.4" stroke={stroke} strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  )
}

export const MenuReportsIcon = (props = {}) => {
  const stroke = props.stroke || "#ADB5BD"
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 28V4"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 28H28"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 23V17.3333"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 23V12"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 23V15.3333"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 23V8"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
